// extracted by mini-css-extract-plugin
export default {"EmailChangeNotificationContainer":"_EmailChangeNotificationContainer--tTMp7","EmailChangeNotification":"_EmailChangeNotification--i1EyM"};